import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { cssVar, mode } from "@chakra-ui/theme-tools";
var $popperBg = cssVar("popper-bg");
var $arrowBg = cssVar("popper-arrow-bg");
var $arrowShadowColor = cssVar("popper-arrow-shadow-color");
var baseStylePopper = {
  zIndex: 10
};

var baseStyleContent = function baseStyleContent(props) {
  var _ref;

  var bg = mode("white", "gray.700")(props);
  var shadowColor = mode("gray.200", "whiteAlpha.300")(props);
  return _ref = {}, _defineProperty(_ref, $popperBg.variable, "colors." + bg), _defineProperty(_ref, "bg", $popperBg.reference), _defineProperty(_ref, $arrowBg.variable, $popperBg.reference), _defineProperty(_ref, $arrowShadowColor.variable, "colors." + shadowColor), _defineProperty(_ref, "width", "xs"), _defineProperty(_ref, "border", "1px solid"), _defineProperty(_ref, "borderColor", "inherit"), _defineProperty(_ref, "borderRadius", "md"), _defineProperty(_ref, "boxShadow", "sm"), _defineProperty(_ref, "zIndex", "inherit"), _defineProperty(_ref, "_focus", {
    outline: 0,
    boxShadow: "outline"
  }), _ref;
};

var baseStyleHeader = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
};
var baseStyleBody = {
  px: 3,
  py: 2
};
var baseStyleFooter = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
};

var baseStyle = function baseStyle(props) {
  return {
    popper: baseStylePopper,
    content: baseStyleContent(props),
    header: baseStyleHeader,
    body: baseStyleBody,
    footer: baseStyleFooter,
    arrow: {}
  };
};

export default {
  parts: parts.keys,
  baseStyle: baseStyle
};